import type { components } from '@fluencelabs/vodopad-admin-api'
import { useQuery } from '@tanstack/react-query'

import client from '@/api/client'
import { unwrapApiData } from '@/api/unwrapApiResult'

export type PermissionScopeInfo = components['schemas']['PermissionScopeInfo']

export const PERMISSION_SCOPES_QUERY_KEY = ['roles', 'scopes'] as const

async function fetchPermissionScopes(): Promise<PermissionScopeInfo[]> {
  const result = await client.GET('/v1/admin/user_roles/scopes')
  return unwrapApiData(result, 'Failed to fetch permission scopes')
}

/** Catalog of every assignable permission scope, with its admin flag. */
export function usePermissionScopes() {
  const query = useQuery({
    queryKey: PERMISSION_SCOPES_QUERY_KEY,
    queryFn: fetchPermissionScopes,
    staleTime: 30 * 60 * 1000,
  })

  return {
    scopes: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
